/* tslint:disable:no-bitwise */
import {Component, HostListener, NgZone, OnInit} from '@angular/core';
import * as L from 'leaflet';
import 'leaflet-canvas-layer';
import {UPNG} from '../../lib/UPNG.js';
import {CanvasLayer} from 'leaflet-canvas-layer';
import {Warp10Connector} from '../../lib/Warp10Connector';
import {EventBus} from '../../lib/EventBus';
import {EventData} from '../../model/EventData';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  currentTick = 0;
  map;
  loading = true;
  lat: number;
  long: number;
  startDate: number;
  mapParams: {
    location: string,
    trackWidth: number;
    trackMarkerSize: number;
    duration: number;
    markerSize: number;
    trackColor: string;
    markerColor: string,
    startDate: number,
    paused: boolean,
    loop: boolean,
    customParams: any
  };
  private infos: any[];
  private ctrlPressed = false;
  private selectedCenter: any;
  private selectionSize = 50;
  private inMove = false;
  private inZoom = false;
  private popup: any;
  private trackOpacity = 0.05;
  private trackWidth = 2;
  private paused = false;
  private resetOnZoom = true;
  private MARKERS = true;
  private TRACK_MARKERS = false;
  private TRACKS = true;
  private markerColor = '#D81B60';
  private markerSize = 5;
  private markerRadius = this.markerSize / 2.0;
  private markerOffset = (this.markerSize - 1) / 2;
  private trackColor = '#00897B';
  private trackMarkerColor = '#00897B';
  private trackMarkerSize = 4;
  private trackMarkerRadius = this.trackMarkerSize / 2.0;
  private trackMarkerOffset = (this.trackMarkerSize - 1) / 2;
  private bgTransparentThreshold = 250;
  private transparentThreshold = 256;
  private step = 1;
  private extraTicks = 50;
  private SQUARE_MARKERS = false;
  private SQUARE_TRACK_MARKERS = false;
  private done = true;
  private running = null;
  private scheduled = false;
  private data = null;
  private ticks = 0;
  private gts = 0;
  private lllat = 0.0;
  private lllon = 0.0;
  private latstep = 0.0;
  private lonstep = 0.0;
  private bucketspan = 0.0;
  private delay = 1;
  private particles = null; // [ 0 ];
  private histcanvas = null;
  private tick: number;
  private stopTick: number;
  private previousPause: boolean;
  private selectedSquare;
  private info: any;
  private LeafIcon = L.Icon.extend({
    options: {
      iconSize: [30, 30],
      shadowSize: [0, 0],
      iconAnchor: [15, 15],
      shadowAnchor: [0, 0],
      popupAnchor: [-3, -76]
    }
  });
  private selectedCenterLatLng: any;
  private selected: any[] = [];
  private bucketcount: number;
  private markers: any[];
  private lastbucket: number;
  private drawContext: { canvas: any; ctx: any; histctx: any; info: any };
  private needRedraw = false;

  constructor(
    private warp10Connector: Warp10Connector,
    private eventBus: EventBus,
    private zone: NgZone
  ) {
  }

  ngOnInit(): void {
    this.eventBus.on('mapTick', newTick => {
      this.tick = newTick;
      this.drawOnMap(this.info, true);
    });

    this.eventBus.on('hideBubble', () => {
      if (this.popup) {
        this.popup.removeFrom(this.map);
        this.popup = undefined;
      }
    });
    this.eventBus.on('hideSelection', () => {
      if (this.selectedSquare) {
        this.map.removeLayer(this.selectedSquare);
      }
      this.selectedSquare = undefined;
      this.selectedCenterLatLng = undefined;
    });

    this.eventBus.on('showBubble', ship => {
      if (this.popup) {
        this.popup.removeFrom(this.map);
        this.popup = undefined;
      }
      const positions = this.getPositions(ship.index, Math.max(0, this.tick - 1));
      if (!isNaN(positions[2]) && !isNaN(positions[3])) {
        this.popup = L.marker([positions[2], positions[3]], {icon: new this.LeafIcon({iconUrl: '/assets/img/pulse.gif'})})
          .addTo(this.map);
      }
    });

    this.eventBus.on('mapParams', mapParams => {
      this.mapParams = this.mapParams || {} as any;
      this.paused = mapParams.paused;
      this.previousPause = this.paused;
      if (!this.paused && this.selectedSquare) {
        this.map.removeLayer(this.selectedSquare);
        this.selectedSquare = undefined;
        this.selectedCenterLatLng = undefined;
      }
      this.mapParams.loop = mapParams.loop;
      this.mapParams.customParams = mapParams.customParams;
      this.trackOpacity = mapParams.trackOpacity;
      this.trackWidth = mapParams.trackWidth;
      this.trackMarkerSize = mapParams.trackMarkerSize;
      this.markerSize = mapParams.markerSize;
      this.trackColor = mapParams.trackColor;
      this.markerColor = mapParams.markerColor;
      this.markerColor = mapParams.markerColor;
      this.markerRadius = this.markerSize / 2.0;
      this.markerOffset = (this.markerSize - 1) / 2;
      this.transparentThreshold = mapParams.transparentThreshold;
      this.delay = mapParams.delay;
      if (this.mapParams.startDate !== mapParams.startDate
        || this.mapParams.duration !== mapParams.duration
        || this.mapParams.location !== mapParams.location
      ) {
        this.mapParams.startDate = mapParams.startDate;
        this.mapParams.duration = mapParams.duration;
        this.mapParams.location = mapParams.location;
        this.sendRequest();
      }
    });
  }

  private sendRequest(): void {
    this.loading = true;
    this.paused = true;
    this.emitPause(this.paused);
    if (this.mapParams) {
      this.warp10Connector.getShips(this.mapParams.location, this.mapParams.startDate, this.mapParams.duration)
        .then((resp: any) => {
          const result = resp.body;
          this.loading = false;
          const decoded = atob(result[0].substring(22));
          this.lat = result[2];
          this.long = result[1];
          const buf = new ArrayBuffer(decoded.length);
          const bufView = new Uint8Array(buf);
          for (let i = 0, strLen = decoded.length; i < strLen; i++) {
            bufView[i] = decoded.charCodeAt(i);
          }
          const png = UPNG.decode(buf);
          // Extract parameters
          const json = png.tabs.iTXt['SenX-TrueTrack'];
          const params = JSON.parse(json);
          this.eventBus.emit(new EventData('gts', {gts: params.gts, count: params.positions}));
          this.infos = params.infos;
          this.ticks = params.bucketcount;
          this.bucketspan = params.bucketspan;
          this.bucketcount = params.bucketcount;
          this.gts = params.gts;
          this.lastbucket = params.lastbucket;
          this.lonstep = params.lonstep;
          this.latstep = params.latstep;
          this.lllat = params.lllat;
          this.lllon = params.lllon;
          this.data = png.data;
          this.markers = new Array(this.gts);
          this.currentTick = 0;
          this.tick = 0;
          this.done = true;
          this.eventBus.emit(new EventData('mapDataSlider', {
            stopTick: this.stopTick - this.extraTicks,
            bucketspan: this.bucketspan,
            bucketcount: this.bucketcount,
            lastbucket: this.lastbucket,
            duration: this.mapParams.duration
          }));
          this.initMap();
        }, () => this.loading = false);
    }
  }

  @HostListener('window:keydown', ['$event'])
  keydownEvent(event: KeyboardEvent): void {
    if (event.key === 'Shift') {
      this.ctrlPressed = true;
    }
  }

  @HostListener('window:keyup', ['$event'])
  keyupEvent(event: KeyboardEvent): void {
    if (event.key === 'Shift') {
      this.ctrlPressed = false;
    }
  }

  private initMap(): void {
    this.currentTick = 0;
    if (!this.map) {
      this.map = L.map('map', {
        center: [this.lat, this.long],
        zoom: 9,
        minZoom: 2.5,
        boxZoom: false,
        trackResize: false
      });
      this.map.on('movestart', () => {
        this.inMove = true;
        if (!this.inZoom) {
          this.previousPause = this.paused;
        }
        if (this.popup) {
          this.popup.removeFrom(this.map);
          this.popup = undefined;
        }
        this.emitPause(true);
      });
      this.map.on('moveend', () => {
        this.emitPause(this.previousPause);
        this.selectedSquare = undefined;
        if (this.previousPause) {
          this.needRedraw = true;
        }
        if (this.selectedCenterLatLng) {
          this.inMove = true;
        }
      });
      this.map.on('zoomstart', () => {
        this.inZoom = true;
        this.previousPause = this.paused;
        this.emitPause(true);
      });
      this.map.on('zoomend', () => {
        if (this.popup) {
          this.popup.removeFrom(this.map);
          this.popup = undefined;
        }
        if (this.selectedCenterLatLng) {
          this.map.panTo(this.selectedCenterLatLng);
        }
        this.emitPause(this.previousPause);
      });
      this.map.on('click', e => {
        if (this.popup) {
          this.popup.removeFrom(this.map);
          this.popup = undefined;
        }
        if (this.ctrlPressed || this.selectedSquare) {
          this.emitPause(true);
          this.selectedCenterLatLng = e.latlng;
          this.selectedCenter = this.map.latLngToLayerPoint(e.latlng);
          const bounds = [
            this.map.layerPointToLatLng(L.point(this.selectedCenter.x - this.selectionSize, this.selectedCenter.y - this.selectionSize)),
            this.map.layerPointToLatLng(L.point(this.selectedCenter.x + this.selectionSize, this.selectedCenter.y + this.selectionSize))
          ];
          this.selectedSquare = L.rectangle(bounds, {color: 'blue', weight: 1}).addTo(this.map);
          this.eventBus.emit(new EventData('LoadShips', undefined));
          this.getShipsInArea();
        }
      });

      L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}', {
        maxZoom: 19,
        attribution: 'Tiles &copy; Esri &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri'
      }).addTo(this.map);
      L.tileLayer('https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png', {
        attribution: 'Map data: &copy; <a href="http://www.openseamap.org">OpenSeaMap</a> contributors'
      }).addTo(this.map);
      const mapCanvasLayer = new CanvasLayer();
      // If we do not inherit from L.CanvasLayer we can setup a delegate to receive events from L.CanvasLayer
      mapCanvasLayer.delegate(this);
      (mapCanvasLayer as any).addTo(this.map);
    } else {
      this.map.setView([this.lat, this.long]);
      this.map.setZoom(9);
    }
    this.paused = false;
    this.emitPause(this.paused);
  }

  private emitPause(paused: boolean): void {
    this.paused = paused;
    if (this.paused && this.selectedSquare) {
      this.map.removeLayer(this.selectedSquare);
      this.selectedSquare = undefined;
    }
    this.eventBus.emit(new EventData('mapDataPause', this.paused));
  }

  // noinspection JSUnusedLocalSymbols
  private onDrawLayer(info): void {
    info.canvas.getContext('2d').clearRect(0, 0, info.canvas.width, info.canvas.height);

    this.info = info;
    if (this.scheduled) {
      return;
    }
    if (this.done) {
      this.done = false;
      if (!this.needRedraw) {
        this.running = this.doParticles(info);
      } else {
        this.drawOnMap(this.info, false);
      }
    } else {
      if (!this.inZoom && !this.inMove) {
        this.done = false;
        if (!this.needRedraw) {
          this.scheduled = true;
          this.running = this.running.then(() => {
            this.scheduled = false;
            this.done = false;
            this.running = this.doParticles(info);
          });
        } else {
          this.drawOnMap(this.info, false);
        }
      } else {
        if (!!this.info) {
          if (this.selectedCenterLatLng) {
            this.drawOnMap(this.info, false);
            this.selectedCenter = this.map.latLngToLayerPoint(this.selectedCenterLatLng);
            const bounds = [
              this.map.layerPointToLatLng(L.point(this.selectedCenter.x - this.selectionSize, this.selectedCenter.y - this.selectionSize)),
              this.map.layerPointToLatLng(L.point(this.selectedCenter.x + this.selectionSize, this.selectedCenter.y + this.selectionSize))
            ];
            this.selectedSquare = L.rectangle(bounds, {color: 'blue', weight: 1}).addTo(this.map);
            if (!this.inMove || this.inZoom) {
              this.eventBus.emit(new EventData('LoadShips', undefined));
              this.getShipsInArea();
            }
          } else {
            this.done = false;
            if (this.needRedraw) {
              this.drawOnMap(this.info, !this.needRedraw);
            } else {
              this.running = this.running.then(() => {
                this.scheduled = false;
                this.done = false;
                this.running = this.doParticles(info);
              });
            }
          }
        }
        this.inMove = false;
        this.inZoom = false;
      }
    }
    this.needRedraw = false;
  }

  private getPositions(gtsidx, tick): (number)[] | (any | number)[] {
    let offset = ((gtsidx * this.ticks) + tick) * 4;
    // ARGB
    let lat = ((this.data[offset + 3] << 8) | (this.data[offset] & 0xFF)) & 0xFFFF;
    let lon = ((this.data[offset + 1] << 8) | (this.data[offset + 2] & 0xFF)) & 0xFFFF;
    if (0 === lat && 0 === lon) {
      lat = NaN;
      lon = NaN;
    } else {
      lat = this.lllat + (lat * this.latstep);
      lon = this.lllon + (lon * this.lonstep);
    }
    if (tick < this.step) {
      return [NaN, NaN, lat, lon];
    } else {
      //
      // Check if within the previous 'step' ticks one is absent, in which case
      // the function will return NaN/NaN as the previous position
      //
      let prevlat = null;
      let prevlon = null;

      if (this.step > 1) {
        for (let j = 1; j < this.step; j++) {
          offset = ((gtsidx * this.ticks) + tick - j) * 4;
          if (0 === this.data[offset] && 0 === this.data[offset + 1] && 0 === this.data[offset + 2] && 0 === this.data[offset + 3]) {
            prevlat = NaN;
            prevlon = NaN;
            break;
          }
        }
      }

      if (null === prevlat) {
        offset = ((gtsidx * this.ticks) + tick - this.step) * 4;
        prevlat = ((this.data[offset + 3] << 8) | (this.data[offset] & 0xFF)) & 0xFFFF;
        prevlon = ((this.data[offset + 1] << 8) | (this.data[offset + 2] & 0xFF)) & 0xFFFF;
        if (0 === prevlat && 0 === prevlon) {
          prevlat = NaN;
          prevlon = NaN;
        } else {
          prevlat = this.lllat + (prevlat * this.latstep);
          prevlon = this.lllon + (prevlon * this.lonstep);
        }
      }
      return [prevlat, prevlon, lat, lon];
    }
  }

  drawOnMap(info: any, drawTraces: boolean = true): void {
    const canvas = info.canvas;
    const ctx = canvas.getContext('2d');
    const histctx = this.histcanvas.getContext('2d');
    if (this.tick < this.ticks) {
      this.markers.fill(null);
      histctx.fillStyle = this.trackMarkerColor;
      for (let particle = 0; particle < this.gts; particle++) {
        if (!!this.particles && !this.particles.includes(particle)) {
          continue;
        }
        if (this.done) {
          // return;
        }
        const positions = this.getPositions(particle, this.tick);

        if (drawTraces) {
          histctx.strokeStyle = this.getCustomParam(particle, 'trackColor', this.trackColor);
          // Draw line if the previous position is not NaN/NaN
          if (this.TRACKS && !isNaN(positions[0]) && !isNaN(positions[1]) && !isNaN(positions[2]) && !isNaN(positions[3])) {
            histctx.beginPath();
            histctx.lineWidth = this.getCustomParam(particle, 'trackWidth', this.trackWidth);
            let dot;
            dot = info.layer._map.latLngToContainerPoint([positions[0], positions[1]]);
            histctx.moveTo(dot.x, dot.y);
            dot = info.layer._map.latLngToContainerPoint([positions[2], positions[3]]);
            histctx.lineTo(dot.x, dot.y);
            histctx.stroke();
          }
        } else {
          histctx.clearRect(0, 0, info.canvas.width, info.canvas.height);
        }

        // Draw marker at current location

        if (!isNaN(positions[2]) && !isNaN(positions[3])) {
          let dot;
          dot = info.layer._map.latLngToContainerPoint([positions[2], positions[3]]);
          this.markers[particle] = dot;
          if (this.TRACK_MARKERS) {
            if (this.SQUARE_TRACK_MARKERS || true) {
              histctx.fillRect(dot.x - this.trackMarkerOffset,
                dot.y - this.trackMarkerOffset, this.trackMarkerSize, this.trackMarkerSize);
            } else {
              histctx.fillStyle = this.getCustomParam(particle, 'markerColor', this.markerColor);
              histctx.beginPath();
              histctx.arc(dot.x, dot.y, this.trackMarkerRadius, 0, 2 * Math.PI);
              histctx.stroke();
            }
          }
        }
      }
    }
    if (this.currentTick < this.ticks + this.extraTicks * this.step) {
      // Now clear the canvas and draw histcanvas with opacity 0.8 on it
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (drawTraces) {
        ctx.drawImage(this.histcanvas, 0, 0);
      }
      // Copy the context onto histctx
      histctx.clearRect(0, 0, this.histcanvas.width, this.histcanvas.height);
      histctx.drawImage(canvas, 0, 0);
      const alpha = histctx.globalAlpha;
      // Will determine length of track
      histctx.globalAlpha = this.trackOpacity;
      histctx.fillStyle = 'white';
      histctx.fillRect(0, 0, canvas.width, canvas.height);
      histctx.globalAlpha = alpha;
      // Now remove the pixels which are 'white' so they become transparent
      const imgdata = histctx.getImageData(0, 0, this.histcanvas.width, this.histcanvas.height);
      const pixels = imgdata.data;
      const size = pixels.length;
      for (let idx = 0; idx < size; idx += 4) {
        // Pixels which are close to white get their transparency set to full
        if (
          this.transparentThreshold < 256
          && pixels[idx] >= this.transparentThreshold
          && pixels[idx + 1] >= this.transparentThreshold
          && pixels[idx + 2] >= this.transparentThreshold
          || (
          this.bgTransparentThreshold < 256
          && pixels[idx] === pixels[idx + 1]
          && pixels[idx] === pixels[idx + 2]
          && pixels[idx] > this.bgTransparentThreshold)
        ) {
          pixels[idx + 3] = 0;
        }
      }
      histctx.putImageData(imgdata, 0, 0);
      // Draw the current markers
      if (this.MARKERS && this.tick < this.ticks) {
        for (let particle = 0; particle < this.gts; particle++) {
          const dot = this.markers[particle];
          if (dot) {
            if (this.SQUARE_MARKERS) {
              ctx.fillStyle = this.getCustomParam(particle, 'markerColor', this.markerColor);
              ctx.fillRect(dot.x - this.getCustomParam(particle, 'markerOffset', this.markerOffset),
                dot.y - this.getCustomParam(particle, 'markerOffset', this.markerOffset),
                this.getCustomParam(particle, 'markerSize', this.markerSize),
                this.getCustomParam(particle, 'markerSize', this.markerSize)
              );
            } else {
              ctx.fillStyle = this.getCustomParam(particle, 'markerColor', this.markerColor);
              ctx.beginPath();
              ctx.arc(dot.x, dot.y, this.getCustomParam(particle, 'markerRadius', this.markerRadius), 0, 2 * Math.PI);
              ctx.fill();
            }
          }
        }
      }
    }
  }

  async doParticles(info): Promise<void> {
    const canvas = info.canvas;
    try {
      // Retrieve canvas
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const ctx = canvas.getContext('2d');
      // Allocate canvas with history
      const oldcanvas = this.histcanvas;
      this.histcanvas = document.createElement('canvas');
      this.histcanvas.width = canvasWidth;
      this.histcanvas.height = canvasHeight;
      this.histcanvas.bounds = info.bounds;
      const histctx = this.histcanvas.getContext('2d');
      // Copy the current canvas to the new one
      if (!this.resetOnZoom && null != oldcanvas) {
        const NE = info.layer._map.latLngToContainerPoint(oldcanvas.bounds._northEast);
        const SW = info.layer._map.latLngToContainerPoint(oldcanvas.bounds._southWest);
        histctx.drawImage(oldcanvas, 0, 0, oldcanvas.width, oldcanvas.height, SW.x, NE.y, (NE.x - SW.x + 1), (SW.y - NE.y + 1));
      }
      this.tick = this.currentTick;
      this.stopTick = this.ticks + (this.extraTicks * this.step);
      this.drawContext = {info, ctx, histctx, canvas};
      this.drawIt();
    } finally {
      this.done = true;
    }
  }

  private drawIt(): void {
    this.zone.runOutsideAngular(() => {
      if (!this.paused && this.tick < this.stopTick) {
        this.currentTick = this.tick;
        this.zone.run(() => this.eventBus.emit(new EventData('mapData', this.currentTick)));
        const start = window.performance.now();
        this.drawOnMap(this.drawContext.info);
        const end = window.performance.now();
        const d = Math.max(1, this.delay - Math.round(end - start));
        this.tick = this.tick + this.step;
        if (this.tick >= this.stopTick - this.extraTicks && this.mapParams.loop) {
          this.drawContext.ctx.clearRect(0, 0, this.drawContext.canvas.width, this.drawContext.canvas.height);
          this.drawContext.histctx.clearRect(0, 0, this.drawContext.canvas.width, this.drawContext.canvas.height);
          this.tick = 0;
        }
        if (d > 1) {
          setTimeout(() => this.drawIt(), d);
        } else {
          setTimeout(() => this.drawIt());
        }
      } else {
        setTimeout(() => this.drawIt(), 500);
      }
    });
  }

  private getCustomParam(particle: number, field: string, defValue: any): any {
    if (
      this.mapParams
      && this.mapParams.customParams
      && this.mapParams.customParams[particle + '']
      && this.mapParams.customParams[particle + ''][field]
    ) {
      return this.mapParams.customParams[particle + ''][field];
    } else {
      return defValue;
    }
  }

  private getShipsInArea(): void {
    this.selected = [];
    for (let particle = 0; particle < this.gts; particle++) {
      const positions = this.getPositions(particle, Math.max(this.tick - 1, 0));
      if (!isNaN(positions[2]) && !isNaN(positions[3])) {
        const p = this.map.latLngToLayerPoint([positions[2], positions[3]]);
        if (
          p.x > this.selectedCenter.x - this.selectionSize
          && p.x < this.selectedCenter.x + this.selectionSize
          && p.y > this.selectedCenter.y - this.selectionSize
          && p.y < this.selectedCenter.y + this.selectionSize
        ) {
          this.selected.push({index: particle, info: this.infos[particle]});
        }
      }
    }
    this.eventBus.emit(new EventData('SelectedShips', this.selected));
  }
}


